import { actionTypes } from '../actions/flags';
import flags from '../flags';

const handlers = {
  [actionTypes.FLAG_TOGGLE_SUCCESS]: (state, action) => ({
    ...state,
    [action.name]: !state[action.name],
  }),
  [actionTypes.FLAG_SET]: (state, action) => {
    // only allow setting of pre-existing flags
    if (action.name in state) {
      console.warn(`setting: ${action.name} to ${action.value}`);
      return {
        ...state,
        [action.name]: action.value,
      };
    }
    console.warn(`${action.name} is not a pre-existing flag`);
    return state;
  },
};

export default (state = flags, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
